<img [src]="urlImage" [ngStyle]="{'width': width}"> 